import { render, staticRenderFns } from "./MarketBranches.vue?vue&type=template&id=4c087228&scoped=true&"
import script from "./MarketBranches.vue?vue&type=script&lang=js&"
export * from "./MarketBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c087228",
  null
  
)

export default component.exports